import { omit } from "lodash";
import { FC } from "react";
import { useHistory } from "react-router";

import Carousel from "components/carousel/Carousel";
import { AutomationsRoutes } from "routes/automations/constants";
import { AutomationCarouselCard } from "routes/automations/shared/components/AutomationCarouselCard";

import { IMacroTemplate } from "../interfaces";
import {
  CONFUSED_CUSTOMER_MACRO_TEMPLATE,
  CUSTOMER_SUPPORT_FOLLOWUP_MACRO_TEMPLATE,
  ESCALATE_TO_MANAGER_MACRO_TEMPLATE,
  FEEDBACK_REQUEST_MACRO_TEMPLATE,
  MARK_AS_SPAM_MACRO_TEMPLATE,
} from "../premade-macros";

const premadeMacros: IMacroTemplate[] = [
  CUSTOMER_SUPPORT_FOLLOWUP_MACRO_TEMPLATE,
  MARK_AS_SPAM_MACRO_TEMPLATE,
  FEEDBACK_REQUEST_MACRO_TEMPLATE,
  ESCALATE_TO_MANAGER_MACRO_TEMPLATE,
  CONFUSED_CUSTOMER_MACRO_TEMPLATE,
];

export const PremadeMacroCarousel: FC = () => {
  return (
    <Carousel>
      {premadeMacros.map(macroTemplate => (
        <PremadeMacro key={macroTemplate.premadeType} macroTemplate={macroTemplate} />
      ))}
    </Carousel>
  );
};

interface IPremadeMacroProps {
  macroTemplate: IMacroTemplate;
}

const PremadeMacro: FC<IPremadeMacroProps> = ({ macroTemplate }) => {
  const history = useHistory();

  const templateWithoutIcon = omit(macroTemplate, "icon");

  const handleSelectPremadeMacro = (): void => {
    history.push(AutomationsRoutes.AddMacro, {
      macroTemplate: templateWithoutIcon,
    });
  };

  return (
    <AutomationCarouselCard
      name={macroTemplate.name}
      icon={macroTemplate.icon}
      premadeType={macroTemplate.premadeType}
      onClick={handleSelectPremadeMacro}
      disabled={false}
    />
  );
};
